export default __webpack_public_path__ + "locales/ja-JP/HotkeysPanel.json?hash=ea276baf5b3050a0dfd9539bc9aa2906";